"use strict";
exports.__esModule = true;
exports.createRequires = void 0;
var sanitizeDependencies = function (dependencies) {
    return typeof dependencies === "function" ? dependencies() : dependencies || {};
};
var createRequires = function (dependencies) {
    var isSanitized = false;
    return function (name) {
        if (!isSanitized) {
            // note: needs to happen inside the inner function for the laziness to work.
            dependencies = sanitizeDependencies(dependencies);
            isSanitized = true;
        }
        if (!(name in dependencies)) {
            throw new Error("Could not require '" + name + "'. '" + name + "' does not exist in dependencies.");
        }
        return dependencies[name];
    };
};
exports.createRequires = createRequires;
//# sourceMappingURL=createRequires.js.map